module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/asset/rank_v1.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/asset/rank_v1.png
// module id = 663
// module chunks = 367